import React from "react";
import Reveal from "../Reveal";
import { useContent } from "../../context/ContentContext";
import { Quote } from "lucide-react";
import { useRFQ } from "../../context/RFQContext";

export function Process() {
  const { content } = useContent();
  const processSteps = content.processSteps || [];
  return (
    <section className="py-20 lg:py-28 bg-[#0f2236]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.2em] text-[#2ED9B8] font-medium">Our process</p>
          <h2 className="mt-3 font-display text-[34px] lg:text-[44px] leading-[1.08] text-foreground">
            Simple, transparent & efficient
          </h2>
          <p className="mt-4 text-[15.5px] text-muted-foreground">
            From inquiry to delivery — a clear, coordinated path for every order.
          </p>
        </Reveal>

        <div className="mt-14 relative grid md:grid-cols-3 gap-x-6 gap-y-12">
          {processSteps.map((s, i) => (
            <Reveal key={s.n} delay={(i % 3) * 90} className="relative">
              <div className="flex items-center gap-4">
                <span className="font-display text-[26px] text-white h-12 w-12 rounded-xl brand-gradient flex items-center justify-center shrink-0">
                  {s.n}
                </span>
                <div className="h-px flex-1 bg-gradient-to-r from-[#a9d9e3] to-transparent" />
              </div>
              <h3 className="mt-5 font-display text-[21px] text-foreground">{s.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Testimonial() {
  const { content } = useContent();
  const t = (content.testimonials || [])[0];
  if (!t) return null;
  return (
    <section className="py-20 lg:py-24">
      <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
        <Reveal>
          <Quote className="h-10 w-10 text-[#2ED9B8] mx-auto opacity-30" />
          <p className="mt-6 font-display text-[24px] lg:text-[32px] leading-[1.35] text-foreground">
            "{t.quote}"
          </p>
          <div className="mt-8">
            <p className="font-medium text-foreground">{t.name}</p>
            <p className="text-sm text-muted-foreground">{t.role}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
